import { parseView } from '#core/lib/cognite/view.ts';
import { InstanceIdType } from '#core/schema/defs.ts';

import {
  AlarmDefinitionSchema,
  AllocatedInjectionStringAgentSchema,
  AllocatedPropertiesStringSchema,
  AllocatedRatesDailyStringAgentSchema,
  AllocatedRatesVfmStringAgentSchema,
  AllocationFactorsFieldAgentSchema,
  AllocationOutputStringSchema,
  AsphalteneCurveSchema,
  AssetSchema,
  ChokeCurveInfoSchema,
  ChokeOutputsNetworkAgentSchema,
  ChokeSchema,
  CompanySchema,
  DailyRollupAssetAgentSchema,
  DailyRollupCompanyAgentSchema,
  DailyRollupFieldAgentSchema,
  DailyRollupLocationAgentSchema,
  DailyRollupOutputAssetSchema,
  DailyRollupOutputCompanySchema,
  DailyRollupOutputFieldSchema,
  DailyRollupOutputLocationSchema,
  DailyRollupOutputReservoirSchema,
  DailyRollupOutputWellSchema,
  DailyRollupReservoirAgentSchema,
  DataDrivenRatesStringAgentSchema,
  DataMappingSchema,
  EntityAgentSchema,
  EntitySchema,
  EspAlarmsAgentSchema,
  EspCableSchema,
  EspCalculationsStringAgentSchema,
  EspCurveDataStringAgentSchema,
  EspLimitsStringAgentSchema,
  EspMeasurementsStringAgentSchema,
  EspMotorSchema,
  EspPumpDetailsSchema,
  EspPumpSchema,
  EstimatedRatesStringAgentSchema,
  EventsStringSchema,
  FieldFormationSchema,
  FieldInputsAgentSchema,
  FieldInputsSchema,
  FieldOutputsAgentSchema,
  FieldOutputsSchema,
  FieldSchema,
  FlatHierarchyAgentSchema,
  FlatHierarchySchema,
  FlowAssuranceAlarmsAgentSchema,
  FlowlineOutputsNetworkAgentSchema,
  FluidCompositionSchema,
  FormationVolumeFactorSchema,
  GasLiftAlarmsAgentSchema,
  GasLiftCalculationsStringAgentSchema,
  GasLiftLimitsStringAgentSchema,
  GasLiftMeasurementsStringAgentSchema,
  GlValveDataSchema,
  InactiveStringAgentSchema,
  InactiveStringSchema,
  InjectionAlarmsAgentSchema,
  InjectionAllocationFactorSchema,
  InjectionHeaderOutputsNetworkAgentSchema,
  InjectionHeaderSchema,
  InjectionPerformanceStringAgentSchema,
  InjPressGuidelineStringAgentSchema,
  InjPressGuidelineStringSchema,
  JointOutputsNetworkAgentSchema,
  JointSchema,
  LiftTypeParameterStringSchema,
  LocationInputsSchema,
  LocationSchema,
  ManifoldInputsSchema,
  MapGridMappingSchema,
  MeasuredInjectionStringAgentSchema,
  MeasuredRatesWellTestStringAgentSchema,
  ModelManagementAlarmsAgentSchema,
  ModelMatchedRatesStringAgentSchema,
  MpfmInputsSchema,
  MpfmOutputsSchema,
  MpfmSchema,
  MpfmWellTestOutputsSchema,
  NetworkAlarmsAgentSchema,
  NetworkInputsAgentSchema,
  NetworkInputsSchema,
  NetworkModelAgentSchema,
  NetworkModelSchema,
  NetworkOutputsFieldAgentSchema,
  NetworkOutputsFieldSchema,
  NetworkOutputsFieldValidatedSchema,
  NetworkOutputsReservoirSchema,
  NetworkOutputsRunsSchema,
  NetworkOutputsStringAgentSchema,
  NetworkOutputsStringSchema,
  NetworkOutputsStringValidatedSchema,
  NetworkRiskOptimizationScenariosSchema,
  NetworkRiskPipelineAgentSchema,
  NetworkRiskPipelineOptimizationScenariosAgentSchema,
  NetworkRiskStringAgentSchema,
  NetworkRiskStringOptimizationScenariosAgentSchema,
  NetworkSchema,
  OpportunityAgentSchema,
  OptimizedRatesNetworkStringAgentSchema,
  OptimizedRatesSrmStringAgentSchema,
  PipelineSchema,
  PriorityRatesStringAgentSchema,
  ProdplanStringAgentSchema,
  ProdplanStringReservoirSectorSchema,
  ProdplanStringSchema,
  ProducerGuidelinesStringAgentSchema,
  ProductionAllocationAlarmsAgentSchema,
  ProsperModelAgentSchema,
  ProsperModelEventLogSchema,
  ProsperModelMetricsSchema,
  ProsperModelSchema,
  PseudoPressureTableSchema,
  PtsOutputsStringAgentSchema,
  PtsOutputsStringSchema,
  PtsReferenceConditionsSchema,
  PumpOutputsNetworkAgentSchema,
  PvtAnalysisStringAgentSchema,
  PvtAnalysisStringSchema,
  RateDiagnosticsStringAgentSchema,
  ReservoirGuidelineSchema,
  ReservoirInputsAgentSchema,
  ReservoirInputsSchema,
  ReservoirOutputsAgentSchema,
  ReservoirOutputsSchema,
  ReservoirProdplanSchema,
  ReservoirSchema,
  SaturationPressureMappingSchema,
  SectorHierarchyAgentSchema,
  SectorHierarchySchema,
  SectorOutputsSchema,
  SectorProdplanSchema,
  SectorSchema,
  SeparatorInputsSchema,
  SeparatorOutputsNetworkAgentSchema,
  SeparatorSchema,
  ShgInjectionSchema,
  ShgProducerGuidelineSchema,
  ShgProductionSchema,
  SPressSettingsSchema,
  SrmOutputsAllEntitiesSchema,
  SrmOutputsStringSchema,
  SrmScenarioInfoSchema,
  SrmSettingsSchema,
  StringAssetSchema,
  StringFluidCompositionAgentSchema,
  StringFluidCompositionSchema,
  StringFunctionSchema,
  StringInputsStaticSchema,
  StringOutputsNetworkAgentSchema,
  StringReservoirInputsSchema,
  SurveillanceAlarmsAgentSchema,
  TicketRegistryAgentSchema,
  ValueTrackingAgentSchema,
  VrrFormationVolumeFactorSchema,
  VrrMonitoringSchema,
  VrrSectorHierarchySchema,
  WaterAnalysisSchema,
  WellBehaviourAlarmsAgentSchema,
  WellChokeMappingSchema,
  WellInputsStaticSchema,
  WellInputsStringReverseSchema,
  WellInputsStringSchema,
  WellMovementAgentSchema,
  WellOutputsExt_1StringSchema,
  WellOutputsStringSchema,
  WellPotentialStringAgentSchema,
  WellSchema,
  WellStatusStringAgentSchema,
  WellTestAnalysisAgentSchema,
  WellTestGaugeStringSchema,
  WellTestInputsStringSchema,
  WellTestModelParametersAgentSchema,
  WellTestOutputsStringSchema,
  WellTestRawSchema,
  WellTestReservoirAnalysisAgentSchema,
  Wf3OutputsStringSchema,
  Wf05FieldOutputsSchema,
  Wf05StringOutputsSchema,
  Wf05StringReservoirOutputsSchema,
  WfAlarmsAgentSchema,
  WfAlarmsSchema,
  WfFieldAlarmsSchema,
  WfReservoirAlarmsSchema,
  WfSectorAlarmsSchema,
  WfStringAlarmsSchema,
  WfWellAlarmsSchema,
} from './validation.ts';

export const AlarmDefinitionView = parseView({
  view: { externalId: 'AlarmDefinition' },
  model: AlarmDefinitionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AllocatedInjectionStringAgentView = parseView({
  view: { externalId: 'AllocatedInjection_String_Agent' },
  model: AllocatedInjectionStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AllocatedPropertiesStringView = parseView({
  view: { externalId: 'AllocatedProperties_String' },
  model: AllocatedPropertiesStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const AllocatedRatesDailyStringAgentView = parseView({
  view: { externalId: 'AllocatedRates_Daily_String_Agent' },
  model: AllocatedRatesDailyStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AllocatedRatesVfmStringAgentView = parseView({
  view: { externalId: 'AllocatedRates_VFM_String_Agent' },
  model: AllocatedRatesVfmStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AllocationFactorsFieldAgentView = parseView({
  view: { externalId: 'AllocationFactors_Field_Agent' },
  model: AllocationFactorsFieldAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AllocationOutputStringView = parseView({
  view: { externalId: 'AllocationOutput_String' },
  model: AllocationOutputStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AsphalteneCurveView = parseView({
  view: { externalId: 'Asphaltene_Curve' },
  model: AsphalteneCurveSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const AssetView = parseView({
  view: { externalId: 'Asset' },
  model: AssetSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ChokeView = parseView({
  view: { externalId: 'Choke' },
  model: ChokeSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ChokeOutputsNetworkAgentView = parseView({
  view: { externalId: 'ChokeOutputs_Network_Agent' },
  model: ChokeOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ChokeCurveInfoView = parseView({
  view: { externalId: 'Choke_Curve_Info' },
  model: ChokeCurveInfoSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const CompanyView = parseView({
  view: { externalId: 'Company' },
  model: CompanySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupAssetAgentView = parseView({
  view: { externalId: 'DailyRollupAsset_Agent' },
  model: DailyRollupAssetAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupCompanyAgentView = parseView({
  view: { externalId: 'DailyRollupCompany_Agent' },
  model: DailyRollupCompanyAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupFieldAgentView = parseView({
  view: { externalId: 'DailyRollupField_Agent' },
  model: DailyRollupFieldAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupLocationAgentView = parseView({
  view: { externalId: 'DailyRollupLocation_Agent' },
  model: DailyRollupLocationAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputAssetView = parseView({
  view: { externalId: 'DailyRollupOutput_Asset' },
  model: DailyRollupOutputAssetSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputCompanyView = parseView({
  view: { externalId: 'DailyRollupOutput_Company' },
  model: DailyRollupOutputCompanySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputFieldView = parseView({
  view: { externalId: 'DailyRollupOutput_Field' },
  model: DailyRollupOutputFieldSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputLocationView = parseView({
  view: { externalId: 'DailyRollupOutput_Location' },
  model: DailyRollupOutputLocationSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputReservoirView = parseView({
  view: { externalId: 'DailyRollupOutput_Reservoir' },
  model: DailyRollupOutputReservoirSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupOutputWellView = parseView({
  view: { externalId: 'DailyRollupOutput_Well' },
  model: DailyRollupOutputWellSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DailyRollupReservoirAgentView = parseView({
  view: { externalId: 'DailyRollupReservoir_Agent' },
  model: DailyRollupReservoirAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DataDrivenRatesStringAgentView = parseView({
  view: { externalId: 'DataDrivenRates_String_Agent' },
  model: DataDrivenRatesStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const DataMappingView = parseView({
  view: { externalId: 'Data_Mapping' },
  model: DataMappingSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspAlarmsAgentView = parseView({
  view: { externalId: 'ESPAlarms_Agent' },
  model: EspAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspCableView = parseView({
  view: { externalId: 'ESPCable' },
  model: EspCableSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspCalculationsStringAgentView = parseView({
  view: { externalId: 'ESPCalculations_String_Agent' },
  model: EspCalculationsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspCurveDataStringAgentView = parseView({
  view: { externalId: 'ESPCurveData_String_Agent' },
  model: EspCurveDataStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspLimitsStringAgentView = parseView({
  view: { externalId: 'ESPLimits_String_Agent' },
  model: EspLimitsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspMeasurementsStringAgentView = parseView({
  view: { externalId: 'ESPMeasurements_String_Agent' },
  model: EspMeasurementsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspMotorView = parseView({
  view: { externalId: 'ESPMotor' },
  model: EspMotorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspPumpView = parseView({
  view: { externalId: 'ESPPump' },
  model: EspPumpSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EspPumpDetailsView = parseView({
  view: { externalId: 'ESP_Pump_Details' },
  model: EspPumpDetailsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EntityView = parseView({
  view: { externalId: 'Entity' },
  model: EntitySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EntityAgentView = parseView({
  view: { externalId: 'Entity_Agent' },
  model: EntityAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EstimatedRatesStringAgentView = parseView({
  view: { externalId: 'EstimatedRates_String_Agent' },
  model: EstimatedRatesStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const EventsStringView = parseView({
  view: { externalId: 'Events_String' },
  model: EventsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FieldView = parseView({
  view: { externalId: 'Field' },
  model: FieldSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FieldFormationView = parseView({
  view: { externalId: 'FieldFormation' },
  model: FieldFormationSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FieldInputsView = parseView({
  view: { externalId: 'FieldInputs' },
  model: FieldInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const FieldInputsAgentView = parseView({
  view: { externalId: 'FieldInputs_Agent' },
  model: FieldInputsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FieldOutputsView = parseView({
  view: { externalId: 'FieldOutputs' },
  model: FieldOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FieldOutputsAgentView = parseView({
  view: { externalId: 'FieldOutputs_Agent' },
  model: FieldOutputsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FlatHierarchyView = parseView({
  view: { externalId: 'FlatHierarchy' },
  model: FlatHierarchySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const FlatHierarchyAgentView = parseView({
  view: { externalId: 'FlatHierarchy_Agent' },
  model: FlatHierarchyAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FlowAssuranceAlarmsAgentView = parseView({
  view: { externalId: 'FlowAssuranceAlarms_Agent' },
  model: FlowAssuranceAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FlowlineOutputsNetworkAgentView = parseView({
  view: { externalId: 'FlowlineOutputs_Network_Agent' },
  model: FlowlineOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FluidCompositionView = parseView({
  view: { externalId: 'FluidComposition' },
  model: FluidCompositionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const FormationVolumeFactorView = parseView({
  view: { externalId: 'Formation_Volume_Factor' },
  model: FormationVolumeFactorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const GlValveDataView = parseView({
  view: { externalId: 'GL_Valve_Data' },
  model: GlValveDataSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const GasLiftAlarmsAgentView = parseView({
  view: { externalId: 'GasLiftAlarms_Agent' },
  model: GasLiftAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const GasLiftCalculationsStringAgentView = parseView({
  view: { externalId: 'GasLiftCalculations_String_Agent' },
  model: GasLiftCalculationsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const GasLiftLimitsStringAgentView = parseView({
  view: { externalId: 'GasLiftLimits_String_Agent' },
  model: GasLiftLimitsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const GasLiftMeasurementsStringAgentView = parseView({
  view: { externalId: 'GasLiftMeasurements_String_Agent' },
  model: GasLiftMeasurementsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InactiveStringAgentView = parseView({
  view: { externalId: 'InactiveString_Agent' },
  model: InactiveStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InactiveStringView = parseView({
  view: { externalId: 'Inactive_String' },
  model: InactiveStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjPressGuidelineStringView = parseView({
  view: { externalId: 'InjPressGuideline_String' },
  model: InjPressGuidelineStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjPressGuidelineStringAgentView = parseView({
  view: { externalId: 'InjPressGuideline_String_Agent' },
  model: InjPressGuidelineStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjectionAlarmsAgentView = parseView({
  view: { externalId: 'InjectionAlarms_Agent' },
  model: InjectionAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjectionHeaderView = parseView({
  view: { externalId: 'InjectionHeader' },
  model: InjectionHeaderSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjectionHeaderOutputsNetworkAgentView = parseView({
  view: { externalId: 'InjectionHeaderOutputs_Network_Agent' },
  model: InjectionHeaderOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjectionPerformanceStringAgentView = parseView({
  view: { externalId: 'InjectionPerformance_String_Agent' },
  model: InjectionPerformanceStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const InjectionAllocationFactorView = parseView({
  view: { externalId: 'Injection_Allocation_Factor' },
  model: InjectionAllocationFactorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const JointView = parseView({
  view: { externalId: 'Joint' },
  model: JointSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const JointOutputsNetworkAgentView = parseView({
  view: { externalId: 'JointOutputs_Network_Agent' },
  model: JointOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const LiftTypeParameterStringView = parseView({
  view: { externalId: 'LiftTypeParameter_String' },
  model: LiftTypeParameterStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const LocationView = parseView({
  view: { externalId: 'Location' },
  model: LocationSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const LocationInputsView = parseView({
  view: { externalId: 'LocationInputs' },
  model: LocationInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ManifoldInputsView = parseView({
  view: { externalId: 'ManifoldInputs' },
  model: ManifoldInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const MapGridMappingView = parseView({
  view: { externalId: 'MapGrid_Mapping' },
  model: MapGridMappingSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const MeasuredInjectionStringAgentView = parseView({
  view: { externalId: 'MeasuredInjection_String_Agent' },
  model: MeasuredInjectionStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const MeasuredRatesWellTestStringAgentView = parseView({
  view: { externalId: 'MeasuredRates_WellTest_String_Agent' },
  model: MeasuredRatesWellTestStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ModelManagementAlarmsAgentView = parseView({
  view: { externalId: 'ModelManagementAlarms_Agent' },
  model: ModelManagementAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ModelMatchedRatesStringAgentView = parseView({
  view: { externalId: 'ModelMatchedRates_String_Agent' },
  model: ModelMatchedRatesStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const MpfmView = parseView({
  view: { externalId: 'Mpfm' },
  model: MpfmSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const MpfmInputsView = parseView({
  view: { externalId: 'MpfmInputs' },
  model: MpfmInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '7',
  },
});

export const MpfmOutputsView = parseView({
  view: { externalId: 'MpfmOutputs' },
  model: MpfmOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const MpfmWellTestOutputsView = parseView({
  view: { externalId: 'MpfmWellTestOutputs' },
  model: MpfmWellTestOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '3',
  },
});

export const NetworkView = parseView({
  view: { externalId: 'Network' },
  model: NetworkSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const NetworkAlarmsAgentView = parseView({
  view: { externalId: 'NetworkAlarms_Agent' },
  model: NetworkAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkInputsView = parseView({
  view: { externalId: 'NetworkInputs' },
  model: NetworkInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkInputsAgentView = parseView({
  view: { externalId: 'NetworkInputs_Agent' },
  model: NetworkInputsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkModelView = parseView({
  view: { externalId: 'NetworkModel' },
  model: NetworkModelSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkModelAgentView = parseView({
  view: { externalId: 'NetworkModel_Agent' },
  model: NetworkModelAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsFieldView = parseView({
  view: { externalId: 'NetworkOutputs_Field' },
  model: NetworkOutputsFieldSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsFieldAgentView = parseView({
  view: { externalId: 'NetworkOutputs_Field_Agent' },
  model: NetworkOutputsFieldAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsFieldValidatedView = parseView({
  view: { externalId: 'NetworkOutputs_Field_Validated' },
  model: NetworkOutputsFieldValidatedSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsReservoirView = parseView({
  view: { externalId: 'NetworkOutputs_Reservoir' },
  model: NetworkOutputsReservoirSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsRunsView = parseView({
  view: { externalId: 'NetworkOutputs_Runs' },
  model: NetworkOutputsRunsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsStringView = parseView({
  view: { externalId: 'NetworkOutputs_String' },
  model: NetworkOutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const NetworkOutputsStringAgentView = parseView({
  view: { externalId: 'NetworkOutputs_String_Agent' },
  model: NetworkOutputsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkOutputsStringValidatedView = parseView({
  view: { externalId: 'NetworkOutputs_String_Validated' },
  model: NetworkOutputsStringValidatedSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkRiskPipelineAgentView = parseView({
  view: { externalId: 'NetworkRiskPipeline_Agent' },
  model: NetworkRiskPipelineAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkRiskPipelineOptimizationScenariosAgentView = parseView({
  view: { externalId: 'NetworkRiskPipeline_OptimizationScenarios_Agent' },
  model: NetworkRiskPipelineOptimizationScenariosAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkRiskStringAgentView = parseView({
  view: { externalId: 'NetworkRiskString_Agent' },
  model: NetworkRiskStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkRiskStringOptimizationScenariosAgentView = parseView({
  view: { externalId: 'NetworkRiskString_OptimizationScenarios_Agent' },
  model: NetworkRiskStringOptimizationScenariosAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const NetworkRiskOptimizationScenariosView = parseView({
  view: { externalId: 'NetworkRisk_OptimizationScenarios' },
  model: NetworkRiskOptimizationScenariosSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const OpportunityAgentView = parseView({
  view: { externalId: 'Opportunity_Agent' },
  model: OpportunityAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const OptimizedRatesNetworkStringAgentView = parseView({
  view: { externalId: 'OptimizedRates_Network_String_Agent' },
  model: OptimizedRatesNetworkStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const OptimizedRatesSrmStringAgentView = parseView({
  view: { externalId: 'OptimizedRates_SRM_String_Agent' },
  model: OptimizedRatesSrmStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PtsReferenceConditionsView = parseView({
  view: { externalId: 'PTS_Reference_Conditions' },
  model: PtsReferenceConditionsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PvtAnalysisStringView = parseView({
  view: { externalId: 'PVTAnalysis_String' },
  model: PvtAnalysisStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PvtAnalysisStringAgentView = parseView({
  view: { externalId: 'PVTAnalysis_String_Agent' },
  model: PvtAnalysisStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PipelineView = parseView({
  view: { externalId: 'Pipeline' },
  model: PipelineSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PriorityRatesStringAgentView = parseView({
  view: { externalId: 'PriorityRates_String_Agent' },
  model: PriorityRatesStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProdplanStringView = parseView({
  view: { externalId: 'Prodplan_String' },
  model: ProdplanStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});

export const ProdplanStringAgentView = parseView({
  view: { externalId: 'Prodplan_String_Agent' },
  model: ProdplanStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProdplanStringReservoirSectorView = parseView({
  view: { externalId: 'Prodplan_String_Reservoir_Sector' },
  model: ProdplanStringReservoirSectorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProducerGuidelinesStringAgentView = parseView({
  view: { externalId: 'ProducerGuidelines_String_Agent' },
  model: ProducerGuidelinesStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProductionAllocationAlarmsAgentView = parseView({
  view: { externalId: 'ProductionAllocationAlarms_Agent' },
  model: ProductionAllocationAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProsperModelView = parseView({
  view: { externalId: 'ProsperModel' },
  model: ProsperModelSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProsperModelEventLogView = parseView({
  view: { externalId: 'ProsperModelEventLog' },
  model: ProsperModelEventLogSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProsperModelMetricsView = parseView({
  view: { externalId: 'ProsperModelMetrics' },
  model: ProsperModelMetricsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ProsperModelAgentView = parseView({
  view: { externalId: 'ProsperModel_Agent' },
  model: ProsperModelAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PseudoPressureTableView = parseView({
  view: { externalId: 'PseudoPressureTable' },
  model: PseudoPressureTableSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PtsOutputsStringView = parseView({
  view: { externalId: 'PtsOutputs_String' },
  model: PtsOutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '5',
  },
});

export const PtsOutputsStringAgentView = parseView({
  view: { externalId: 'PtsOutputs_String_Agent' },
  model: PtsOutputsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const PumpOutputsNetworkAgentView = parseView({
  view: { externalId: 'PumpOutputs_Network_Agent' },
  model: PumpOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const RateDiagnosticsStringAgentView = parseView({
  view: { externalId: 'RateDiagnostics_String_Agent' },
  model: RateDiagnosticsStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirView = parseView({
  view: { externalId: 'Reservoir' },
  model: ReservoirSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirInputsView = parseView({
  view: { externalId: 'ReservoirInputs' },
  model: ReservoirInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirInputsAgentView = parseView({
  view: { externalId: 'ReservoirInputs_Agent' },
  model: ReservoirInputsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirOutputsView = parseView({
  view: { externalId: 'ReservoirOutputs' },
  model: ReservoirOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirOutputsAgentView = parseView({
  view: { externalId: 'ReservoirOutputs_Agent' },
  model: ReservoirOutputsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirGuidelineView = parseView({
  view: { externalId: 'Reservoir_Guideline' },
  model: ReservoirGuidelineSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ReservoirProdplanView = parseView({
  view: { externalId: 'Reservoir_Prodplan' },
  model: ReservoirProdplanSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ShgInjectionView = parseView({
  view: { externalId: 'SHG_INJECTION' },
  model: ShgInjectionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ShgProductionView = parseView({
  view: { externalId: 'SHG_PRODUCTION' },
  model: ShgProductionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ShgProducerGuidelineView = parseView({
  view: { externalId: 'SHG_Producer_Guideline' },
  model: ShgProducerGuidelineSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SPressSettingsView = parseView({
  view: { externalId: 'SPressSettings' },
  model: SPressSettingsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SrmOutputsAllEntitiesView = parseView({
  view: { externalId: 'SRMOutputs_All_Entities' },
  model: SrmOutputsAllEntitiesSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SrmOutputsStringView = parseView({
  view: { externalId: 'SRMOutputs_String' },
  model: SrmOutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SrmSettingsView = parseView({
  view: { externalId: 'SRMSettings' },
  model: SrmSettingsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SrmScenarioInfoView = parseView({
  view: { externalId: 'SRM_Scenario_Info' },
  model: SrmScenarioInfoSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SaturationPressureMappingView = parseView({
  view: { externalId: 'Saturation_Pressure_Mapping' },
  model: SaturationPressureMappingSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SectorView = parseView({
  view: { externalId: 'Sector' },
  model: SectorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SectorHierarchyView = parseView({
  view: { externalId: 'SectorHierarchy' },
  model: SectorHierarchySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SectorHierarchyAgentView = parseView({
  view: { externalId: 'SectorHierarchy_Agent' },
  model: SectorHierarchyAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SectorOutputsView = parseView({
  view: { externalId: 'SectorOutputs' },
  model: SectorOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SectorProdplanView = parseView({
  view: { externalId: 'Sector_Prodplan' },
  model: SectorProdplanSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SeparatorView = parseView({
  view: { externalId: 'Separator' },
  model: SeparatorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SeparatorInputsView = parseView({
  view: { externalId: 'SeparatorInputs' },
  model: SeparatorInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SeparatorOutputsNetworkAgentView = parseView({
  view: { externalId: 'SeparatorOutputs_Network_Agent' },
  model: SeparatorOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringFluidCompositionView = parseView({
  view: { externalId: 'StringFluidComposition' },
  model: StringFluidCompositionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringFluidCompositionAgentView = parseView({
  view: { externalId: 'StringFluidComposition_Agent' },
  model: StringFluidCompositionAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringInputsStaticView = parseView({
  view: { externalId: 'StringInputs_Static' },
  model: StringInputsStaticSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringOutputsNetworkAgentView = parseView({
  view: { externalId: 'StringOutputs_Network_Agent' },
  model: StringOutputsNetworkAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringFunctionView = parseView({
  view: { externalId: 'String_Function' },
  model: StringFunctionSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringReservoirInputsView = parseView({
  view: { externalId: 'String_Reservoir_Inputs' },
  model: StringReservoirInputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const StringAssetView = parseView({
  view: { externalId: 'String_asset' },
  model: StringAssetSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const SurveillanceAlarmsAgentView = parseView({
  view: { externalId: 'SurveillanceAlarms_Agent' },
  model: SurveillanceAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const TicketRegistryAgentView = parseView({
  view: { externalId: 'TicketRegistry_Agent' },
  model: TicketRegistryAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const VrrFormationVolumeFactorView = parseView({
  view: { externalId: 'VRR_Formation_Volume_Factor' },
  model: VrrFormationVolumeFactorSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const VrrMonitoringView = parseView({
  view: { externalId: 'VRR_Monitoring' },
  model: VrrMonitoringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const VrrSectorHierarchyView = parseView({
  view: { externalId: 'VRR_SectorHierarchy' },
  model: VrrSectorHierarchySchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const ValueTrackingAgentView = parseView({
  view: { externalId: 'ValueTracking_Agent' },
  model: ValueTrackingAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const Wf05FieldOutputsView = parseView({
  view: { externalId: 'WF05_Field_Outputs' },
  model: Wf05FieldOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const Wf05StringOutputsView = parseView({
  view: { externalId: 'WF05_String_Outputs' },
  model: Wf05StringOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const Wf05StringReservoirOutputsView = parseView({
  view: { externalId: 'WF05_String_Reservoir_Outputs' },
  model: Wf05StringReservoirOutputsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WaterAnalysisView = parseView({
  view: { externalId: 'Water_Analysis' },
  model: WaterAnalysisSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellView = parseView({
  view: { externalId: 'Well' },
  model: WellSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellBehaviourAlarmsAgentView = parseView({
  view: { externalId: 'WellBehaviourAlarms_Agent' },
  model: WellBehaviourAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellInputsStaticView = parseView({
  view: { externalId: 'WellInputs_Static' },
  model: WellInputsStaticSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellInputsStringView = parseView({
  view: { externalId: 'WellInputs_String' },
  model: WellInputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellInputsStringReverseView = parseView({
  view: { externalId: 'WellInputs_String_Reverse' },
  model: WellInputsStringReverseSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellMovementAgentView = parseView({
  view: { externalId: 'WellMovement_Agent' },
  model: WellMovementAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellOutputsExt_1StringView = parseView({
  view: { externalId: 'WellOutputs_Ext_1_String' },
  model: WellOutputsExt_1StringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellOutputsStringView = parseView({
  view: { externalId: 'WellOutputs_String' },
  model: WellOutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '4',
  },
});

export const WellPotentialStringAgentView = parseView({
  view: { externalId: 'WellPotential_String_Agent' },
  model: WellPotentialStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellStatusStringAgentView = parseView({
  view: { externalId: 'WellStatus_String_Agent' },
  model: WellStatusStringAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestAnalysisAgentView = parseView({
  view: { externalId: 'WellTestAnalysis_Agent' },
  model: WellTestAnalysisAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestGaugeStringView = parseView({
  view: { externalId: 'WellTestGauge_String' },
  model: WellTestGaugeStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '3',
  },
});

export const WellTestInputsStringView = parseView({
  view: { externalId: 'WellTestInputs_String' },
  model: WellTestInputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestOutputsStringView = parseView({
  view: { externalId: 'WellTestOutputs_String' },
  model: WellTestOutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestModelParametersAgentView = parseView({
  view: { externalId: 'WellTest_ModelParameters_Agent' },
  model: WellTestModelParametersAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestRawView = parseView({
  view: { externalId: 'WellTest_Raw' },
  model: WellTestRawSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellTestReservoirAnalysisAgentView = parseView({
  view: { externalId: 'WellTest_ReservoirAnalysis_Agent' },
  model: WellTestReservoirAnalysisAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_field_well_surveillance_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WellChokeMappingView = parseView({
  view: { externalId: 'Well_Choke_Mapping' },
  model: WellChokeMappingSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const Wf3OutputsStringView = parseView({
  view: { externalId: 'Wf3Outputs_String' },
  model: Wf3OutputsStringSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfAlarmsView = parseView({
  view: { externalId: 'WfAlarms' },
  model: WfAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '4',
  },
});

export const WfAlarmsAgentView = parseView({
  view: { externalId: 'WfAlarms_Agent' },
  model: WfAlarmsAgentSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-agent-solution-data-model',
    externalId: 'ipso_network_model_agent_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfFieldAlarmsView = parseView({
  view: { externalId: 'WfFieldAlarms' },
  model: WfFieldAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfReservoirAlarmsView = parseView({
  view: { externalId: 'WfReservoirAlarms' },
  model: WfReservoirAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfSectorAlarmsView = parseView({
  view: { externalId: 'WfSectorAlarms' },
  model: WfSectorAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfStringAlarmsView = parseView({
  view: { externalId: 'WfStringAlarms' },
  model: WfStringAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '1',
  },
});

export const WfWellAlarmsView = parseView({
  view: { externalId: 'WfWellAlarms' },
  model: WfWellAlarmsSchema.extend(InstanceIdType.shape),
  dataModel: {
    space: 'dm-ipso-solution-data-model',
    externalId: 'ipso_solution_data_model',
    instanceSpace: 'dm-ipso-solution-instances',
    version: '2',
  },
});
